export enum TrustInventoryPathEnum {
  SALES_MANAGEMENT = '1',
  INVENTORY_SUPPORT = '2',
}
export const TrustInventoryPath = [
  { label: '販売在庫管理システム', value: TrustInventoryPathEnum.SALES_MANAGEMENT },
  { label: '棚卸サポートシステム', value: TrustInventoryPathEnum.INVENTORY_SUPPORT },
];
